var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Error404"},[_c('div',{staticClass:"info"},[_vm._v(_vm._s(_vm.$t('404message')))]),_c('Icon',{attrs:{"icon":"fas fa-rainbow fa-2x"}}),_c('div',{staticClass:"forOfor"},[_vm._v("404")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }